import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonToolbar,
  Button,
} from 'react-bootstrap';
import { findById } from '../../../core/utils';
import { tourType } from './CatchPropTypes';
import TourRouteTable from './TourRouteTable';
import EventDetailModal from './EventDetailModalContainer';
import EventFilterToolbar from './EventFilterToolbar';

class TourRouteTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleAdd = this.handleAdd.bind(this);
    this.getToolbar = this.getToolbar.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showEvent = this.showEvent.bind(this);
    this.clearRoute = this.clearRoute.bind(this);
  }
  componentWillMount() {
    if (this.props.places.length === 0) {
      this.props.requestPlaceOptions();
    }
  }
  getToolbar(readOnly) {
    if (readOnly) {
      return null;
    }
    // console.log(this.props.tour.state);
    const state = (this.props.tour.state === 'DR' && this.props.tour.tour_stops.length > 0);
    const add = <Button bsStyle="success" onClick={this.handleAdd}><i className="fa fa-plus" /> Add</Button>;

    return (
      <ButtonToolbar>{ add }
        {state && (
        <Button bsStyle="danger" onClick={this.clearRoute}>
          <i className="fa fa-trash" /> Clear Route
        </Button>
        )}
        <EventFilterToolbar
          groups={this.props.tour.groups}
          filter={this.props.filter}
          eventFilterSet={this.props.eventFilterSet}
        />
      </ButtonToolbar>);
  }
  clearRoute() {
    this.props.clearRoute(this.props.tour.id);
  }
  handleAdd(e) {
    e.preventDefault();
    this.setState({
      event: -1,
      show: true,
    });
  }
  findEvent(id) {
    // New EVENT
    if (id === -1) {
      return { tour: this.props.tour.id, all_day: true };
    }
    const stops = this.props.tour.tour_stops;
    for (let i = 0, len = stops.length; i < len; i++) {
      console.log('stop id, id => ', stops[i].id, id)
      if (stops[i].id === Number(id)) {
        return this.props.tour.tour_stops[i];
      }
      const idx = stops[i].events.findIndex(findById, id);
      if (idx !== -1) {
        return this.props.tour.tour_stops[i].events[idx];
      }
    }
    console.log('that should not happen... findEvent: ', id);
    return { tour: this.props.tour.id, all_day: true };
  }
  showEvent(e) {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('data-item');
    if (id) {
      console.log('show event: ', id);
      this.setState({
        event: id,
        show: true,
      });
    }
  }
  closeModal() {
    this.setState({
      show: false,
      event: null,
    });
  }
  render() {
    const toolbar = this.getToolbar(this.props.readOnly);
    return (
      <div className="col-sm-12 planner">
        {toolbar}
        { this.state.show && (
        <EventDetailModal
          event={this.findEvent(this.state.event)}
          show={this.state.show}
          onClose={this.closeModal}
          editing={!this.props.readOnly}
        />
        )}
        <TourRouteTable
          tourStops={this.props.tour.tour_stops}
          showEvent={this.showEvent}
          filter={this.props.filter}
        />
      </div>
    );
  }
}
TourRouteTab.propTypes = {
  tour: PropTypes.shape(tourType).isRequired,
  places: PropTypes.arrayOf(PropTypes.object).isRequired,
  filter: PropTypes.object.isRequired,
  addEvent: PropTypes.func.isRequired,
  editEvent: PropTypes.func.isRequired,
  removeEvent: PropTypes.func.isRequired,
  eventFilterSet: PropTypes.func.isRequired,
  clearRoute: PropTypes.func.isRequired,
  requestPlaceOptions: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};
TourRouteTab.defaultProps = {
  readOnly: false,
};
export default TourRouteTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRouteTab.js